import { useEffect, useState } from "react";
import s from '../styles/Avatar.module.css';

export default function Avatar({ userId, editable = false, onEditClick, version = 0 }) {
  const [avatarSrc, setAvatarSrc] = useState("");
  const [loading, setLoading] = useState(true);
  const [refreshTick, setRefreshTick] = useState(0);

  useEffect(() => {
    const onAvatarUpdated = (event) => {
      const updatedUserId = event?.detail?.userId;
      if (!updatedUserId || Number(updatedUserId) === Number(userId)) {
        setRefreshTick((prev) => prev + 1);
      }
    };

    window.addEventListener('avatar-updated', onAvatarUpdated);
    return () => window.removeEventListener('avatar-updated', onAvatarUpdated);
  }, [userId]);

  useEffect(() => {
    let isCancelled = false;
    let objectUrl = "";

    const loadAvatar = async () => {
      setLoading(true);
      if (!userId) {
        if (!isCancelled) {
          setAvatarSrc("");
          setLoading(false);
        }
        return;
      }

      try {
        const token = localStorage.getItem('user_token') || localStorage.getItem('jwtToken');
        const res = await fetch(`/api/user_api/avatar/${userId}?v=${version || 0}&r=${refreshTick}`, {
          headers: {
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          ...(token ? {} : { credentials: 'include' }),
        });

        if (!res.ok) {
          if (!isCancelled) setAvatarSrc("");
          return;
        }

        const blob = await res.blob();
        objectUrl = URL.createObjectURL(blob);
        if (!isCancelled) setAvatarSrc(objectUrl);
      } catch (err) {
        console.error("Ошибка загрузки аватара:", err);
        if (!isCancelled) setAvatarSrc("");
      } finally {
        if (!isCancelled) setLoading(false);
      }
    };

    loadAvatar();

    return () => {
      isCancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [userId, version, refreshTick]);

  if (loading){
    return (
        <div className={s.loader_container}>
          <div className={s.spinner}></div>
        </div>
      );
  }

  if (!avatarSrc) {
    if (!editable) {
      return (
        <img
          src="/default.jpg"
          alt="Аватар"
          style={{
            borderRadius: "50%",
            width: "100%",
            height: "100%",
            objectFit: "cover"
          }}
        />
      );
    }

    return (
      <div className={s.avatarRoot} role={editable ? "button" : undefined} onClick={editable ? onEditClick : undefined}>
        <img
          src="/default.jpg"
          alt="Аватар"
          className={s.avatarImg}
        />
        {editable ? <span className={s.editBadge}>✎</span> : null}
      </div>
    );
  }

  if (!editable) {
    return (
      <img
        src={avatarSrc}
        alt="Аватар"
        onError={() => setAvatarSrc("")}
        style={{
          borderRadius: "50%",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          border: "2px solid white"
        }}
      />
    );
  }

  return (
    <div className={s.avatarRoot} role={editable ? "button" : undefined} onClick={editable ? onEditClick : undefined}>
      <img
        src={avatarSrc}
        alt="Аватар"
        className={s.avatarImg}
        onError={() => setAvatarSrc("")}
      />
      {editable ? <span className={s.editBadge}>✎</span> : null}
    </div>
  );
}
